<div class="row justify-content-center mb-2">
  <app-search-field class="col-9"></app-search-field>
  <img
    class="col-auto ml-3 menu-icon pointer-cursor"
    src="assets/svg/ico-menu-circle.svg"
  />
</div>

<div class="content">
  <div *ngFor="let floor of floors">
    <app-building-floor-item
      [name]="floor.floor"
      [wingName]="floor.wing"
    ></app-building-floor-item>
    <div *ngFor="let unit of floor.unitsCount">
      <app-building-unit-item [name]="unit"></app-building-unit-item>
    </div>
  </div>
</div>
